import Pagination from "@material-ui/lab/Pagination";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useStyles = () =>
  makeThemedStyles("WorkflowPagination", (theme) => {
    return {
      pagination: {
        marginTop: "15px",
        display: "flex",
        fontSize: "20px",
        justifyContent: "center",
      },
    };
  });

const WorkflowPagination = React.forwardRef(
  (
    props: React.PropsWithChildren<{
      page: number;
      totalItemCount: number;
      rowsPerPage: number;
      caption: string;
      onChange: (event: React.ChangeEvent<unknown>, value: number) => void;
    }>,
    ref: any
  ) => {
    const styles = useStyles()();

    return (
      <div ref={ref} className={styles.pagination}>
        <span className="label">
          {props.totalItemCount} {props.caption}
        </span>
        <Pagination
          count={
            Math.floor(props.totalItemCount / props.rowsPerPage) +
            (props.totalItemCount % props.rowsPerPage > 0 ? 1 : 0)
          }
          size="medium"
          page={props.page}
          onChange={props.onChange}
        />
      </div>
    );
  }
);

export default WorkflowPagination;
